// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3O3Gn","bigColWidth":"Table_bigColWidth__azdM-","biggerColWidth":"Table_biggerColWidth__2sZ2e","row":"Table_row__2Nxml","col":"Table_col__J9lMc"};